<!-- <div>
    <u>
      <h3 class="heading" style="text-align: center; margin-top: 50px;">Login</h3>
    </u>
  
    <div class="container" style="width: max-content; margin-top: 50px;">
      <form>
        <div class="col">
          <label for="username">Username</label>
          <input type="text" name="username" [(ngModel)]="loginRequest.Username" class="form-control"
            placeholder="Username" required>
        </div>
        <div class="col">
          <label for="password">Password</label>
          <input type="password" name="password" [(ngModel)]="loginRequest.Password" class="form-control"
            placeholder="Password" required>
        </div>
        <div class="col">
          <button class="btn btn-primary" style="margin-top: 10px; width:400px;" (click)="onSubmit()">Login</button>
        </div>
      </form>
    </div>
  </div>
   -->

   
   <div class="full">
    <div class="container">
        <div class="forms-container">
            <div class="signin-signup">
                <form class="sign-in-form" (submit)="onSubmit()">
                    <h2 class="title">Sign in</h2>
                    <p>We make failure visible and prescribe right maintenance right time.</p>

                    <div class="input-field form-group required">
                        <i class="lnr lnr-user"></i>
                        <input name="UserName" [(ngModel)]="loginRequest.Username" type="text" placeholder="User Name" />
                    </div>
                    <!-- <span class="text-danger">
                        <i class="pi pi-info-circle"></i>&nbsp;User name is required.
                    </span> -->
                    <div class="input-field form-group required">
                        <i class="lnr lnr-lock"></i>
                        <input name="Password" [(ngModel)]="loginRequest.Password" type="password" placeholder="Password" />
                    </div>
                    <!-- <span class="text-danger">
                        <i class="pi pi-info-circle"></i>&nbsp;Password is required.
                    </span> -->
                    <input type="submit" value="Login" class="btn solid" />
                    <!-- <p><a [routerLink]="['/ForgotPassword']" >Forgot Password</a></p> -->
                </form>

                <!-- <form class="sign-up-form" (submit)="onSubmit()">

                    <h2 class="title">Sign up</h2>
                    <p>We make failure visible and prescribe right maintenance right time.</p>

                    <div class="form-group row">
                        <div class="col-sm-6">
                            <div class="col form-group required">
                                <i class="lnr lnr-user"></i>
                                <input type="text" class="form-control" [(ngModel)]="UserName"
                                    placeholder="User Name">
                            </div>
                            <span class="text-danger">
                                <i class="pi pi-info-circle"></i>&nbsp;Required
                            </span>
                        </div>
                        <div class="col-sm-6">
                            <div class="col form-group required">
                                <i class="lnr lnr-apartment"></i>
                                <input type="text" class="form-control" [(ngModel)]="Company"
                                    placeholder="Company Name">
                            </div>
                            <span class="text-danger">
                                <i class="pi pi-info-circle"></i>&nbsp;Required
                            </span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-6">
                            <div class="col form-group required">
                                <i class="lnr lnr-user"></i>
                                <input type="text" class="form-control" [(ngModel)]="Firstname"
                                    placeholder="First name">
                            </div>
                            <span class="text-danger">
                                <i class="pi pi-info-circle"></i>&nbsp;Required
                            </span>
                        </div>
                        <div class="col-sm-6">
                            <div class="col form-group required">
                                <i class="lnr lnr-user"></i>
                                <input type="text" class="form-control" [(ngModel)]="Lastname"
                                    placeholder="Last name">
                            </div>
                            <span class="text-danger">
                                <i class="pi pi-info-circle"></i>&nbsp;Required
                            </span>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="col form-group required">
                                <i class="lnr lnr-phone"></i>
                                <input type="text" class="form-control" [(ngModel)]="PhoneNumber"
                                    placeholder="Phone Number">
                            </div>
                            <span class="text-danger">
                                <i class="pi pi-info-circle"></i>&nbsp;Enter Valid Phone Number
                            </span>
                            <span class="text-danger">
                                <i class="pi pi-info-circle"></i>&nbsp;Required
                            </span>
                        </div>

                        <div class="col-sm-6">
                            <div class="col form-group required">
                                <i class="lnr lnr-envelope"></i>
                                <input type="email" class="form-control" [(ngModel)]="Email" email="true"
                                    placeholder="Email">
                            </div>
                            <span style="margin-left: 0px;" class="text-danger">
                                <i class="pi pi-info-circle"></i>&nbsp;Please Enter Valid Email Address
                            </span>
                            <span style="margin-left: 0px;" class="text-danger">
                                <i class="pi pi-info-circle"></i>&nbsp;Required
                            </span>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="col form-group required">
                                <i class="lnr lnr-lock"></i>
                                <input type="password" class="form-control" [(ngModel)]="Password"
                                    placeholder="Password">
                            </div>

                            <span style="margin-left: 0px;" class="text-danger">
                                <i class="pi pi-info-circle"></i>&nbsp;Required
                            </span>
                        </div>
                        <div class="col-sm-6">
                            <div class="col form-group required">
                                <i class="lnr lnr-lock"></i>
                                <input type="password" class="form-control"
                                    placeholder="Confirm Password">
                            </div>
                            <span class="text-danger">
                                <i class="pi pi-info-circle"></i> Passwords do not match
                            </span>
                        </div>
                    </div>

                    <input type="submit" class="btn" value="Sign up" />

                    <p class="social-text">Connect with us on</p>
                    <div class="social-media">

                        <a data-bs-toggle="tooltip" data-bs-placement="top" title="LinkedIn"
                            href="https://linkedin.com/in/dynamic-prescriptive-maintenance-08bb101b8"
                            class="social-icon">
                            <i class="fab fa-linkedin-in"></i>
                        </a>
                    </div>
                </form> -->
            </div>
        </div>
         <div class="panels-container"> 
            <div class="panel left-panel">
                <!-- <div class="content">
                    <h3>New here ?</h3>
                    <p>
                        Contact us to get more detail
                    </p>
                    <button (click)="signUpBtn()" class="btn transparent" id="sign-up-btn"> Sign up</button>
                </div> -->
                <img src="dist/DPM/assets/img/DPM_LOGO.png" class="image" alt="" />
            </div>
            <div class="panel right-panel">
                <!-- <div class="content">
                    <h3>One of us ?</h3>
                    <p>
                        Then what are you waiting for
                    </p>
                    <button (click)="signInBtn()" class="btn transparent" id="sign-in-btn">Sign in</button>
                </div> -->
                <!-- <img src="../../assets/img/bg-login.jpg" class="image" alt="" /> -->
            </div>
        </div>
    </div>
</div>